import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PriceRobotProduct} from "../../../services/price-robot-product";

@Component({
    selector: '[app-price-robot-product-header]',
    templateUrl: './price-robot-product-header.component.html',
    styleUrls: ['./price-robot-product-header.component.scss']
})
export class PriceRobotProductHeaderComponent implements OnInit {

    @Input() filter;

    @Output() doRefresh = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit(): void {
    }

    refresh(number: number, active: string, asc: string) {
        const eventdata = {number, sort: active, direction: asc};
        this.doRefresh.emit(eventdata);
    }
}
